// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensoryRoundId } from './FoodSensoryRound';
import { foodSensoryAnalystId } from './FoodSensoryAnalyst';
import { z } from 'zod';
export const foodSensoryRoundSubmissionId = (z.number());
export const foodSensoryRoundSubmission = z.object({
    id: foodSensoryRoundSubmissionId,
    round_id: foodSensoryRoundId,
    analyst_id: foodSensoryAnalystId,
    submitted_at: z.date(),
});
export const foodSensoryRoundSubmissionInitializer = z.object({
    id: foodSensoryRoundSubmissionId.optional(),
    round_id: foodSensoryRoundId,
    analyst_id: foodSensoryAnalystId,
    submitted_at: z.date().optional(),
});
export const foodSensoryRoundSubmissionMutator = z.object({
    id: foodSensoryRoundSubmissionId.optional(),
    round_id: foodSensoryRoundId.optional(),
    analyst_id: foodSensoryAnalystId.optional(),
    submitted_at: z.date().optional(),
});
//# sourceMappingURL=FoodSensoryRoundSubmission.js.map